export default __webpack_public_path__ + "static/media/placeholder_store05-es-mobile.96be9033.png";